/**
 * Auth-gated Wenco HTML pages. Content is bundled (generated JSON) and only
 * turned into a blob: URL after PrivateRoute + tenant/internal checks.
 * Never reference /wenco/... under public/.
 */

export const WENCO_PAGE = {
  PILOT_TOURENOPTIMIERUNG: "pilot-tourenoptimierung",
  PILOT_TOURENOPTIMIERUNG_1: "pilot-tourenoptimierung-1",
  INTERN_TOUREN_DASHBOARD: "intern-touren-dashboard"
};

const LOADERS = {
  [WENCO_PAGE.PILOT_TOURENOPTIMIERUNG]: () =>
    import("./wenco/generated/pilot-tourenoptimierung.html.json"),
  [WENCO_PAGE.PILOT_TOURENOPTIMIERUNG_1]: () =>
    import("./wenco/generated/pilot-tourenoptimierung-1.html.json"),
  [WENCO_PAGE.INTERN_TOUREN_DASHBOARD]: () =>
    import("./wenco/generated/intern-touren-dashboard.html.json")
};

export function loadWencoPageHtml(pageKey) {
  const loader = LOADERS[pageKey];
  if (!loader) {
    return Promise.reject(new Error(`Unknown Wenco page: ${pageKey}`));
  }
  return loader().then(mod => mod.default || mod);
}
